import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { PartnerModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useUpdatePartner() {
  const { authInfo } = useAuth()
  const { t } = useTranslation(['partners', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { patcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const updatePartner = async (
    partnerId: number
  ): Promise<PartnerModel | null> => {
    setLoading(true)
    setError(null)
    setSuccess(null)
    try {
      const data = await patcher<PartnerModel>(
        `${CONFIG.BOUNCE_API}/api/v1/partners/${partnerId}/favorite`
      )
      setSuccess(t('partners:partners.hook.successfully-updated'))
      return data
    } catch (error) {
      console.error(error)
      if (error instanceof ApiError) {
        setError(getErrorMessage(error.data))
      } else {
        setError(t('exceptions:unknown'))
      }
      return null
    } finally {
      setLoading(false)
    }
  }
  return {
    updatePartner,
    loading,
    error,
    success,
    resetState,
  }
}
